module.exports = __webpack_public_path__ + "static/media/adminIcon.13f716b8.svg";